import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'
import VueSignature from "vue-signature-pad";
import VueHtmlToPaper from 'vue-html-to-paper';
import VueHtml2pdf from 'vue-html2pdf'
import VueSocketIO from 'vue-socket.io'
import socket from './@core/mixins/socket.js'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Global Components
import './global-components'

import axios from '@/libs/axios'   // 用你啱啱改好嗰個 axios instance

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// Axios Mock Adapter
import '@/@fake-db/db'

// Print 設定
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ],
  timeout: 1000,
  autoClose: true,
  windowTitle: window.document.title,
}
window.axios = axios               // 全域備用（某啲舊 script 可直接用 axios）

Vue.use(VueHtmlToPaper, options)
Vue.use(ToastPlugin)
Vue.use(VueSignature)
Vue.use(ModalPlugin)
Vue.use('vue-moment')
Vue.prototype.$http = axios        // 全域掛載
Vue.use(VueHtml2pdf)
Vue.use(VueCompositionAPI)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// ✅ 建立 Socket.IO 連線設定
const socketConnection = new VueSocketIO({
  debug: false,
  connection: 'https://www.cloudfit.hk:3215', // 直接連 Socket Server
  vuex: {
    store,
    actionPrefix: 'SOCKET_',
    mutationPrefix: 'SOCKET_'
  },
  options: {
    autoConnect: true, // 👈 建議開啟，讓 Socket 自動連線
    timeout: 5000,
  }
})

Vue.use(socketConnection)

// ✅ 混入共用方法
Vue.mixin({
  methods: {
    test: socket.methods.test,
    test2: socket.methods.test2,
    permission_check: socket.methods.permission_check
  },
})

require('@core/assets/fonts/feather/iconfont.css')
require('@core/scss/core.scss')
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

// ✅ 啟動 Vue App
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  mounted() {
    // 👇 一旦 Socket.IO 連線成功，即時顯示 socket.id
    this.$socket.on('connect', () => {
     // console.log('✅ Socket connected, id =', this.$socket.id)
      // 可選：存入 localStorage，方便 PHP login 用
      localStorage.setItem('socket_id', this.$socket.id)

      // 👇 這裡檢查如果用戶已登入（有 token / user 資料）
      const user = JSON.parse(localStorage.getItem('userData')) // 假設登入時存咗 user
      if (user) {
        //console.log('🔄 User is logged in, rejoining room')
        // 自動通知 Node 重新加入房間
        const socket_id = this.$socket.id

        this.$http.post(process.env.VUE_APP_API_BASE+'/socket/join/', {
          socket_id: localStorage.getItem('socket_id'),
          token: user.token
        })
      }
    })
  }
}).$mount('#app')
